import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import fetchOrder from "areas/order/hoc/fetch-order"
import HolidayMsg from "areas/order/holiday-msg"
import OrderNumber from "areas/order/order-number"
import {
  showHolidayResize,
  holidayResizeDates as getHolidayResizeDates,
  showHolidayRma,
} from "helpers/holiday"

import { FormContainer, FormWrapper, MsgWrap, Text } from "../components"
import Heading from "../heading"

import OrderForm from "./order-form"

const Resize = ({ data }) => {
  const [orderData, setData] = useState(null)

  useEffect(() => {
    setData(data)
  }, [data])

  if (
    orderData &&
    orderData.order &&
    orderData.order.number_of_eligible_items > 0
  ) {
    return <OrderForm orderData={orderData} />
  }
  const holidayResizeDates = getHolidayResizeDates()
  return (
    <FormContainer>
      <FormWrapper>
        <Heading rmaType="resize" />
        {orderData &&
          orderData.order &&
          orderData.order.number_of_eligible_items === 0 && (
            <MsgWrap borderColor="#B4AF34">
              Order does not have any items eligible for resizing. Please
              contact{" "}
              <a
                className="nowrap"
                href={`mailto:${sl.config.customer_service_email}`}
              >
                {sl.config.customer_service_email}
              </a>{" "}
              for assistance.
            </MsgWrap>
          )}
        {showHolidayResize() ? (
          <MsgWrap style={{ borderColor: "#B4AF34" }}>
            Please note: We have extended our FREE ring resizing period until{" "}
            {holidayResizeDates.end}, for all orders placed after{" "}
            {holidayResizeDates.start}.
          </MsgWrap>
        ) : showHolidayRma() ? (
          <HolidayMsg style={{ borderColor: "#B4AF34" }} />
        ) : null}

        <Text>
          Complete this form to submit a request to resize your{" "}
          {sl.config.site_title} ring. If you have any issues, email us at{" "}
          <a
            className="nowrap"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}
          </a>
          .
        </Text>
        <br />
        <Text>
          Please enter your order number, found in your confirmation or shipment
          email, or your certificate number, located on the certificate of
          authenticity that came with your item and the email address used to
          place the order.
        </Text>
        {orderData?.errors && (
          <Typography color="error" mb={2} mt={2}>
            {orderData.errors[0]}
          </Typography>
        )}
      </FormWrapper>
      <OrderNumber
        rmaType="resize"
        setData={setData}
        validatePath="/secure/api/v10/order/order_info_for_rma"
      />
    </FormContainer>
  )
}

Resize.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(Resize)
